import { createReducer } from "@reduxjs/toolkit";
import { addAnagraficaCedacri, erroreAddAnagraficaCedacriAction, getRicercaNdgCedacri, resetClienteRicercatoAction, resetClienteSelezionatoAction, resetErroreAddAnagraficaCedacriAction, resetNdg, setNdgAction } from "./actions";
import { RicercaAnagrafeReducerType } from "./types";

const initialState: RicercaAnagrafeReducerType = {
  ndg: '',
  clienteRicercato: undefined,
  erroreAddAnagraficaCedacri: undefined,
  clienteSelezionato: undefined,
};

export const ricercaAnagrafeReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setNdgAction, (state, action) => {
      state.ndg = action.payload;
    })
    .addCase(getRicercaNdgCedacri.pending, (state) => {
      state.clienteRicercato = initialState.clienteRicercato;
    })
    .addCase(getRicercaNdgCedacri.fulfilled, (state, action) => {
      state.clienteRicercato = action.payload;
    })
    .addCase(resetNdg, (state) => {
      state.ndg = initialState.ndg;
    })
    .addCase(addAnagraficaCedacri.pending, (state, action) => {
      state.clienteSelezionato = initialState.clienteSelezionato
    })
    .addCase(addAnagraficaCedacri.fulfilled, (state, action) => {
      state.clienteSelezionato = action.payload;
    })
    .addCase(resetClienteRicercatoAction, (state) => {
      state.clienteRicercato = initialState.clienteRicercato;
    })
    .addCase(resetClienteSelezionatoAction, (state) => {
      state.clienteSelezionato = initialState.clienteSelezionato;
    })
    .addCase(erroreAddAnagraficaCedacriAction, (state, action) => {
      state.erroreAddAnagraficaCedacri = action.payload;
    })
    .addCase(resetErroreAddAnagraficaCedacriAction, (state) => {
      state.erroreAddAnagraficaCedacri = initialState.erroreAddAnagraficaCedacri;
    })

});
